'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenCartIcon = function (_React$Component) {
  (0, _inherits3.default)(FullscreenCartIcon, _React$Component);

  function FullscreenCartIcon() {
    (0, _classCallCheck3.default)(this, FullscreenCartIcon);
    return (0, _possibleConstructorReturn3.default)(this, (FullscreenCartIcon.__proto__ || (0, _getPrototypeOf2.default)(FullscreenCartIcon)).apply(this, arguments));
  }

  (0, _createClass3.default)(FullscreenCartIcon, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var count = this.props.cartItemsCount > 0 ? _react2.default.createElement(
        'span',
        null,
        this.props.cartItemsCount
      ) : false;
      return _react2.default.createElement(
        'span',
        {
          className: 'fullscreen-icon fullscreen-cart-icon has-custom-focus',
          onClick: function onClick() {
            return _this2.props.showCart && _this2.props.showCart();
          },
          title: 'Cart',
          'aria-label': 'Cart',
          tabIndex: 0
        },
        _react2.default.createElement(
          'button',
          { tabIndex: -1 },
          _react2.default.createElement(
            'svg',
            {
              viewBox: '0 0 18 16',
              xmlns: 'http://www.w3.org/2000/svg',
              xmlnsXlink: 'http://www.w3.org/1999/xlink'
            },
            _react2.default.createElement(
              'defs',
              null,
              _react2.default.createElement('path', { id: 'aa', d: 'M0 4h18l-3.033 12H3z' }),
              _react2.default.createElement(
                'mask',
                { id: 'cc', x: '0', y: '0', width: '18', height: '12', fill: '#fff' },
                _react2.default.createElement('use', { xlinkHref: '#aa' })
              ),
              _react2.default.createElement('path', { d: 'M14 5A5 5 0 0 0 4 5', id: 'bb' }),
              _react2.default.createElement(
                'mask',
                { id: 'dd', x: '0', y: '0', width: '10', height: '10', fill: '#fff' },
                _react2.default.createElement('use', { xlinkHref: '#bb' })
              )
            ),
            _react2.default.createElement(
              'g',
              {
                strokeWidth: '2',
                stroke: 'currentColor',
                fill: 'none',
                fillRule: 'evenodd'
              },
              _react2.default.createElement('use', { mask: 'url(#cc)', xlinkHref: '#aa' }),
              _react2.default.createElement('use', { mask: 'url(#dd)', xlinkHref: '#bb' })
            )
          )
        ),
        count
      );
    }
  }]);
  return FullscreenCartIcon;
}(_react2.default.Component);

exports.default = FullscreenCartIcon;